import { Flex, Icon } from '@chakra-ui/react'
import React from 'react'
import negativeSentimentIcon from '~/assets/svgs/icon-sentiment-negative.svg?react'
import neutralSentimentIcon from '~/assets/svgs/icon-sentiment-neutral.svg?react'
import positiveSentimentIcon from '~/assets/svgs/icon-sentiment-positive.svg?react'
import { textStyleKeys } from '~/themes/textStyles'

interface OverallSentimentStatusProps {
  overallSentimentScore: number
  personType: string
}

const sentimentText = (sentiment: number): string => {
  return sentiment >= 1 ? 'Positive' : sentiment <= -1 ? 'Negative' : 'Neutral'
}

const sentimentIcon = (sentiment: number): SVGComponent => {
  return sentiment >= 1
    ? positiveSentimentIcon
    : sentiment <= -1
      ? negativeSentimentIcon
      : neutralSentimentIcon
}

export const OverallSentimentStatus = ({
  overallSentimentScore,
  personType,
}: OverallSentimentStatusProps) => {
  return (
    <Flex gap="0.5rem" alignItems="center">
      <Icon
        height="1.65rem"
        width="1.65rem"
        borderRadius="1.5rem"
        as={sentimentIcon(overallSentimentScore)}
      />
      <Flex
        flexDirection="column"
        gap="0"
        height="100%"
        justifyContent="center"
      >
        <Flex textColor="gray.1300" textStyle={textStyleKeys.Body2}>
          {personType}
        </Flex>
        <Flex textColor="gray.700" textStyle={textStyleKeys.Body3}>
          {sentimentText(overallSentimentScore)}
        </Flex>
      </Flex>
    </Flex>
  )
}
